import type { Study, ConcentrationTimePoint } from '@bioavail/shared-types';
import { createArm, createStudy } from '../factory';
import {
  RouteOfAdministration as ROA,
  ArmRole as AR,
  DoseUnit as DU,
  ConcentrationUnit as CU,
  TimeUnit as TU,
  CalculationMode as CM,
  AucInterval as AI,
} from '@bioavail/shared-types';

/**
 * Worked example: Food-effect study — fed vs fasted (relative F).
 */
export function foodEffectExample(): Study {
  const fed: ConcentrationTimePoint[] = [
    { time: 0.5, concentration: 0, isBlq: true },
    { time: 1, concentration: 95, isBlq: false },
    { time: 2, concentration: 260, isBlq: false },
    { time: 4, concentration: 310, isBlq: false },
    { time: 6, concentration: 220, isBlq: false },
    { time: 8, concentration: 140, isBlq: false },
    { time: 12, concentration: 52, isBlq: false },
    { time: 16, concentration: 18, isBlq: false },
    { time: 24, concentration: 1.8, isBlq: false },
  ];
  const fasted: ConcentrationTimePoint[] = [
    { time: 0.25, concentration: 80, isBlq: false },
    { time: 0.5, concentration: 240, isBlq: false },
    { time: 1, concentration: 410, isBlq: false },
    { time: 2, concentration: 280, isBlq: false },
    { time: 4, concentration: 150, isBlq: false },
    { time: 6, concentration: 80, isBlq: false },
    { time: 8, concentration: 42, isBlq: false },
    { time: 12, concentration: 12, isBlq: false },
    { time: 16, concentration: 3, isBlq: false },
    { time: 24, concentration: 0.25, isBlq: false },
  ];
  return createStudy({
    name: 'Example — Food Effect (Fed vs Fasted)',
    mode: CM.Relative,
    aucInterval: AI.ZeroToInf,
    arms: [
      createArm({ id: 'arm-test', label: 'Fed (100 mg)', route: ROA.Oral, role: AR.Test, dose: 100, doseUnit: DU.Mg, concentrationUnit: CU.NgPerMl, timeUnit: TU.Hour, dataPoints: fed }),
      createArm({ id: 'arm-ref', label: 'Fasted (100 mg)', route: ROA.Oral, role: AR.Reference, dose: 100, doseUnit: DU.Mg, concentrationUnit: CU.NgPerMl, timeUnit: TU.Hour, dataPoints: fasted }),
    ],
  });
}
